import axios from 'axios';
import get from 'lodash-es/get';
import { parseString } from 'xml2js';
import { stripPrefix } from 'xml2js/lib/processors';

const isExternalURL = (url) => new URL(url).origin !== location.origin;

export const proxyUrl = () => {
    return axios.defaults.proxyURL;
};
export const transformToProxyUrl = (url) => {
    return isExternalURL(url) ? proxyUrl() : url;
};
export const configProxyAxios = (url) => {
    if(isExternalURL(url)){
        return {
            headers: {
                'X-Proxy-Url': url,
                'X-Proxy-Cookie': null,
            }
        };
    }else{
        return {};
    }
};

class OGCError extends Error {
    constructor(message, code) {
        super(message);
        this.name = 'OGCError';
        this.code = code;
    }
}

export const interceptOGCError = (response, throwException = true) => {
    if (typeof response.data === "string") {
        if (response.data.indexOf("ExceptionReport") > 0) {
            try {
                parseString(response.data, {
                    tagNameProcessors: [stripPrefix],
                    explicitArray: false,
                    mergeAttrs: true
                }, (ignore, result) => {
                    let data = result.ServiceExceptionReport;
                    let message = get(data, "ExceptionReport.Exception.ExceptionText") || get(data, "ServiceException._");
                    message = message ? message.replace(/(\r\n|\n|\r)/gm, "").trim() : "Undefined OGC Service Error";

                    let code = get(data, "ExceptionReport.Exception.exceptionCode") || get(data, "ServiceException.code")
                    throw new OGCError(message, code);
                })
            } catch (err) {
                if(throwException){
                    throw err;
                }else{
                    return {
                        code: err.code,
                        text: err.message,
                    }
                }
            }
        }
    }
};